import { PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { HomeFlexModel, HomeModel } from '@core/models/domains/home-page-flex';
import { HomeUiService } from '../home-ui.service';
import { UtmService } from '@core/services/utm.service';
import { isPlatformBrowser } from '@angular/common';

export const EcolodgeFlexResolver: ResolveFn<any> = (
 route: ActivatedRouteSnapshot,
 state: RouterStateSnapshot,
 homeUiService: HomeUiService = inject(HomeUiService),
 utmService: UtmService = inject(UtmService),
 platformId = PLATFORM_ID
) => {
 utmService.checkRouteParams(route.queryParamMap);
 return [];
};
